export default function CsharpCertificate() {
  return (
    <h2>Csharp Certificate</h2>
  );
}
